<template>
  <div class="container">
    <h1>服务协议</h1>

    <h2>一、协议总则</h2>
    <ol>
      <li>
        本服务协议（以下简称“本协议”）是用户（以下简称“您”）与<span
          class="placeholder"
          >郑州森迈光电科技有限公司</span
        >（以下简称“我们”）之间就使用<span class="placeholder">禽舍环控</span
        >（以下简称“本APP”）所提供的各项服务所订立的有效合约。您在使用本APP各项服务前，应仔细阅读并充分理解本协议全部条款，特别是涉及免除或限制我们责任的条款、对您权利进行限制的条款以及约定争议解决方式的条款。您使用本APP服务，即表示您已充分理解并接受本协议的全部内容，自愿受本协议约束。
      </li>
      <li>
        我们有权根据业务发展和法律法规变化，对本协议内容进行修改和更新，修改后的协议内容将在本APP显著位置进行公示。若您在协议修改更新后继续使用本APP服务，即视为您已接受修改后的协议；若您不接受，应立即停止使用本APP服务。
      </li>
    </ol>

    <h2>二、服务内容</h2>
    <ol>
      <li>
        本APP为您提供<span class="placeholder"
          >[环控设备数据远程查看、远程命令下发、数据统计和汇总、报警实时通知等]</span
        >服务，具体服务内容以本APP实际展示为准。我们将尽力保障服务的稳定性和可用性，但因技术故障、网络问题、第三方服务异常等不可抗力或非我们可控因素导致服务中断、延迟或无法使用的，我们不承担相应责任，但会尽力协助解决问题并恢复服务。
      </li>
      <li>
        我们有权根据业务发展需要，对本APP提供的服务内容、功能模块、界面设计等进行调整、更新或优化，无需事先征得您的同意，但会通过合理方式（如APP内通知、公告等）向您告知相关变更。
      </li>
    </ol>

    <h2>三、用户权利与义务</h2>
    <h3>（一）用户权利</h3>
    <ol>
      <li>
        您有权在符合本协议约定的前提下，正常使用本APP提供的各项服务，对服务质量进行评价和反馈，并就服务相关问题向我们提出咨询、投诉或建议。
      </li>
      <li>
        在您遵守本协议及相关法律法规的前提下，您对在本APP上创建的合法账户及相关信息享有使用权。
      </li>
    </ol>

    <h3>（二）用户义务</h3>
    <ol>
      <li>
        您应妥善保管您的APP账户名、密码等账户信息，不得将账户信息泄露给他人或允许他人使用您的账户。因您自身原因导致账户信息泄露、账户被盗用或遭受其他损失的，由您自行承担责任，我们不承担赔偿责任，但会在合理范围内协助您找回账户或采取其他补救措施。
      </li>
      <li>
        您在使用本APP服务过程中，应遵守国家法律法规、社会公德及本协议约定，不得利用本APP从事任何违法违规活动，包括但不限于：
        <ul>
          <li>
            （1）发布、传播含有反动、淫秽、暴力、恐怖、诽谤、侮辱他人等违法或不良信息；
          </li>
          <li>（2）侵犯他人知识产权、肖像权、名誉权、隐私权等合法权益；</li>
          <li>
            （3）恶意攻击、破坏本APP的系统安全、数据安全或干扰其他用户正常使用服务；
          </li>
          <li>
            （4）未经授权获取或使用本APP的相关数据、技术信息或其他商业秘密；
          </li>
          <li>（5）其他违反法律法规或损害我们及其他用户合法权益的行为。</li>
        </ul>
      </li>
      <li>
        您应尊重本APP的知识产权，不得对本APP的软件程序、界面设计、内容信息等进行反向工程、反向编译、修改、复制、传播或用于其他未经授权的商业用途。
      </li>
    </ol>

    <h2>四、服务的终止与暂停</h2>
    <ol>
      <li>
        若您违反本协议约定或国家法律法规规定，我们有权根据情节严重程度，采取警告、限制账户功能、暂停提供部分或全部服务、永久封禁账户等措施，且无需向您承担任何赔偿责任。
      </li>
      <li>
        若您需要终止使用本APP服务，可通过本APP内的注销账户功能（若有）或向我们提出书面申请办理账户注销手续。账户注销后，您将无法再使用该账户登录和使用本APP服务，我们将按照相关法律法规规定处理您的账户信息。
      </li>
      <li>
        因业务调整、系统升级、维护等原因，我们可能会暂时暂停提供部分或全部服务，并会提前通过APP内通知、公告等方式告知您暂停服务的时间和恢复时间（紧急情况除外）。若暂停服务给您造成合理损失的，我们将根据实际情况给予适当补偿（不可抗力或非我们可控因素导致的暂停服务除外）。
      </li>
    </ol>

    <h2>五、免责声明</h2>
    <ol>
      <li>
        本APP提供的信息、数据等内容均来源于我们的平台服务，我们已尽力确保其准确性和完整性，但不对其绝对准确性和完整性作出保证。您依据本APP提供的信息、数据作出的决策或采取的行动，风险由您自行承担。
      </li>
      <li>
        因不可抗力（如自然灾害、战争、政府行为等）、意外事件（如火灾、地震、网络中断等）或非我们可控的其他因素导致本APP服务无法正常提供或您遭受损失的，我们不承担赔偿责任，但会在合理范围内协助您减少损失。
      </li>
    </ol>

    <h2>六、违约责任</h2>
    <ol>
      <li>
        若您违反本协议约定，给我们或其他用户造成损失的，您应承担全部赔偿责任，包括但不限于直接损失、间接损失（如商誉损失、预期利益损失等）及为追偿损失而支出的合理费用（如律师费、诉讼费、差旅费等）。
      </li>
      <li>
        若因我们违反本协议约定，给您造成直接损失的，我们将根据您的实际损失承担相应的赔偿责任，但不承担间接损失赔偿责任（法律法规另有规定的除外）。
      </li>
    </ol>

    <h2>七、争议解决</h2>
    <ol>
      <li>
        本协议的订立、效力、履行、解释及争议解决均适用中华人民共和国法律（不包括香港、澳门特别行政区及台湾地区法律）。
      </li>
      <li>
        因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方均有权向<span
          class="placeholder"
          >[APP开发公司所在地有管辖权的人民法院]</span
        >提起诉讼。
      </li>
    </ol>

    <h2>八、其他条款</h2>
    <ol>
      <li>
        本协议构成双方之间关于使用本APP服务的完整协议，取代双方此前就相关事宜达成的任何口头或书面协议、谅解或安排。
      </li>
      <li>
        若本协议中的任何条款因违反法律法规或被有权机关认定为无效、可撤销，该条款不影响本协议其他条款的效力，其他条款仍然有效并对双方具有约束力。
      </li>
      <li>
        您对本协议的任何疑问、意见或建议，可发送邮件至<span
          class="placeholder"
          >[smsmart_zzsm@sina.com]</span
        >与我们联系，我们将在合理时间内予以回复。
      </li>
    </ol>
  </div>
</template>

<script>
export default {};
</script>

<style>
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "PingFang SC", "Microsoft YaHei", sans-serif;
  line-height: 1.6;
  color: #333;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
}
.container {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
h1 {
  text-align: center;
  color: #2c3e50;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}
.update-info {
  text-align: center;
  color: #7f8c8d;
  margin-bottom: 30px;
  font-size: 0.9em;
}
h2 {
  color: #3498db;
  margin-top: 30px;
  padding-left: 10px;
  border-left: 4px solid #3498db;
}
p,
li {
  text-align: justify;
}
ul {
  padding-left: 20px;
}
li {
  margin-bottom: 8px;
}
.contact-box {
  background-color: #f1f8ff;
  padding: 20px;
  border-radius: 6px;
  margin-top: 30px;
}
.footer {
  text-align: center;
  margin-top: 40px;
  color: #95a5a6;
  font-size: 0.9em;
}
@media (max-width: 600px) {
  body {
    padding: 10px;
  }
  .container {
    padding: 20px;
  }
}
</style>